module.exports = __webpack_public_path__ + "static/media/ox.54c874e9.png";